import { render } from "./TableHeaderWithSort.vue?vue&type=template&id=f9ad5284&scoped=true"
import script from "./TableHeaderWithSort.vue?vue&type=script&lang=js"
export * from "./TableHeaderWithSort.vue?vue&type=script&lang=js"

import "./TableHeaderWithSort.vue?vue&type=style&index=0&id=f9ad5284&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9ad5284"]])

export default __exports__